module.exports = __webpack_public_path__ + "static/media/loginPages.85a832b7.jpg";